export class FeatureMapping {
    id: number;
    menu: string;
    subMenu: string;
    routeName: string;
    name: string;
    enableFeature: boolean;
    constructor(objAccess?: FeatureMapping, modifierObj?: {}) {
        if (objAccess) Object.assign(this, objAccess);

        if (modifierObj) Object.assign(this, modifierObj);
    }
}

//Future coming from DB
export class LookupFeatures {
    featureMapping: FeatureMapping[] = [];
    constructor() {
        this.featureMapping = [
            {
                id: 1,
                menu: 'Workbench',
                subMenu: 'Queued',
                routeName: 'workbench/queued',
                name: 'View Workbench - Queued',
                enableFeature: true
            },
            {
                id: 2,
                menu: 'Workbench',
                subMenu: 'My Tasks',
                routeName: 'workbench/my-tasks',
                name: 'View Workbench - My Tasks',
                enableFeature: true
            },
            {
                id: 3,
                menu: 'Workbench',
                subMenu: 'My Involved',
                routeName: 'workbench/my-involved',
                name: 'View Workbench - Involved',
                enableFeature: true
            },
            {
                id: 4,
                menu: 'Workbench',
                subMenu: 'My Archive',
                routeName: 'workbench/my-archive',
                name: 'View Workbench - Archive',
                enableFeature: true
            },
            {
                id: 6,
                menu: 'Workbench',
                subMenu: 'Manage',
                routeName: 'workbench/manage',
                name: 'Manage Nodes',
                enableFeature: true
            },

            {
                id: 15,
                menu: 'COE',
                subMenu: 'Search COE',
                routeName: 'coe/search',
                name: 'Search COE',
                enableFeature: true
            },
            {
                id: 16,
                menu: 'COE',
                subMenu: 'COE Review Log',
                routeName: 'coe/review-log',
                name: 'Search COE Review Log',
                enableFeature: true
            },
            {
                id: 17,
                menu: 'COE',
                subMenu: 'Create eCOE',
                routeName: 'coe/ecoe',
                name: 'Create COE Wizard',
                enableFeature: true
            },
            {
                id: 18,
                menu: 'COE',
                subMenu: 'Enter Paper COE',
                routeName: 'coe/papercoe',
                name: 'Create Paper COE',
                enableFeature: true
            },
            {
                id: 19,
                menu: 'COE',
                subMenu: 'Print Bulk COEs',
                routeName: 'coe/print-bulk-coes',
                name: 'Print Bulk COEs',
                enableFeature: true
            },
            {
                id: 25,
                menu: 'Children',
                subMenu: 'Search Children',
                routeName: 'children/search',
                name: 'Search Students',
                enableFeature: true
            },
            {
                id: 26,
                menu: 'Children',
                subMenu: 'Group Enrollments',
                routeName: 'children/group-enrollment',
                name: 'Edit Group Student School Enrollments',
                enableFeature: true
            },
            {
                id: 27,
                menu: 'Children',
                subMenu: 'Group Services',
                routeName: 'children/group-services',
                name: 'Edit Group Student Services',
                enableFeature: true
            },
            {
                id: 28,
                menu: 'Children',
                subMenu: 'Group Communications',
                routeName: 'children/group-communication-events',
                name: 'Edit Group Communication Events',
                enableFeature: true
            },
            {
                id: 29,
                menu: 'Manage Duplicates',
                subMenu: 'Resolve Duplicates',
                routeName: 'children/deduplication',
                name: 'View Student Duplicates',
                enableFeature: true
            },
            {
                id: 29,
                menu: 'Manage Duplicates',
                subMenu: 'Merge Children',
                routeName: 'children/deduplication/merge',
                name: 'Merge Students',
                enableFeature: true
            },
            {
                id: 29,
                menu: 'Manage Duplicates',
                subMenu: 'Split Children',
                routeName: 'children/deduplication/split',
                name: 'Split Students',
                enableFeature: true
            },
            {
                id: 30,
                menu: 'Children',
                subMenu: 'Resolve SSIDs',
                routeName: '/children/calpad-ssid',
                name: 'Resolve CALPADS SSID Resolutions',
                enableFeature: true
            },

            {
                id: 35,
                menu: 'Child Reports',
                subMenu: 'Counts',
                routeName: 'reports/instant-eligibility-counts',
                name: 'Search Student Eligibility Lists',
                enableFeature: true
            },
            {
                id: 36,
                menu: 'Child Reports',
                subMenu: 'Enrollments',
                routeName: 'reports/enrollment-report',
                name: 'Search Active Student Lists',
                enableFeature: true
            },
            {
                id: 37,
                menu: 'Child Reports',
                subMenu: 'Services',
                routeName: 'reports/student-service-lists',
                name: 'Search Student Service Lists',
                enableFeature: true
            },
            {
                id: 38,
                menu: 'Child Reports',
                subMenu: 'Academic Risk',
                routeName: 'reports/academic-risk-report',
                name: 'Search Academic Risk Report',
                enableFeature: true
            },
            {
                id: 39,
                menu: 'Child Reports',
                subMenu: 'PFS',
                routeName: 'reports/pfs-report',
                name: 'Search PFS Lists',
                enableFeature: true
            },
            {
                id: 40,
                menu: 'Child Reports',
                subMenu: 'Communication Events',
                routeName: 'reports/communication-events-report',
                name: 'Search Communication Events Report',
                enableFeature: true
            },
            {
                id: 41,
                menu: 'Child Reports',
                subMenu: 'Graduation',
                routeName: 'reports/graduation-report',
                name: 'Search Student Graduation Lists',
                enableFeature: true
            },
            {
                id: 42,
                menu: 'Child Reports',
                subMenu: 'INA/ILP',
                routeName: 'reports/ina-ilp-report',
                name: 'Search INA/ILP Reports',
                enableFeature: true
            },

            {
                id: 45,
                menu: 'Data Monitoring Reports',
                subMenu: 'Grade Age Alignment',
                routeName: 'data-monitoring-reports/grade-age-alignment',
                name: 'Search Grade Age Alignment',
                enableFeature: true
            },
            {
                id: 46,
                menu: 'Data Monitoring Reports',
                subMenu: 'R Enroll, No SSID',
                routeName: 'data-monitoring-reports/r-enrolled-missing-ssid',
                name: 'R Enrolled and Missing SSID',
                enableFeature: true
            },
            {
                id: 47,
                menu: 'Data Monitoring Reports',
                subMenu: 'Missing W Date',
                routeName: 'data-monitoring-reports/missing-withdrawal-date',
                name: 'Missing Withdrawal Date',
                enableFeature: true
            },
            {
                id: 48,
                menu: 'Data Monitoring Reports',
                subMenu: 'Missing SE Date',
                routeName: 'data-monitoring-reports/missing-service-end-date',
                name: 'Missing EOS Date',
                enableFeature: true
            },
            {
                id: 49,
                menu: 'Data Monitoring Reports',
                subMenu: 'R Enroll, Not EIP',
                routeName: 'data-monitoring-reports/r-enrollment-not-eip',
                name: 'R Enrollment and Not EIP',
                enableFeature: true
            },
            {
                id: 50,
                menu: 'Data Monitoring Reports',
                subMenu: 'N Enroll, Not EIP',
                routeName: 'data-monitoring-reports/n-enrollment-not-eip',
                name: 'N Enrollment and Not EIP',
                enableFeature: true
            },
            {
                id: 51,
                menu: 'Data Monitoring Reports',
                subMenu: 'EIP, Not Enrolled',
                routeName: 'data-monitoring-reports/eip-n-enrollment',
                name: 'EIP and No Enrollment',
                enableFeature: true
            },
            {
                id: 52,
                menu: 'Data Monitoring Reports',
                subMenu: 'QAD Age Eligible',
                routeName: 'data-monitoring-reports/qad-age-eligible',
                name: 'QAD Age Eligible',
                enableFeature: true
            },
            {
                id: 53,
                menu: 'Data Monitoring Reports',
                subMenu: 'Dup, Enrollment Line',
                routeName: 'data-monitoring-reports/duplicate-enrollment-line',
                name: 'Duplicate Enrollment Line',
                enableFeature: true
            },
            {
                id: 54,
                menu: 'Data Monitoring Reports',
                subMenu: 'Duplicate Service',
                routeName: 'data-monitoring-reports/duplicate-service',
                name: 'DuplicateService',
                enableFeature: true
            },
            {
                id: 55,
                menu: 'Data Monitoring Reports',
                subMenu: 'No DD, Not Serviced S/I',
                routeName: 'data-monitoring-reports/missing-departure-date-summer-intersession-service',
                name: 'Missing Departure Date And Summer Intersession Service',
                enableFeature: true
            },
            {
                id: 56,
                menu: 'Data Monitoring Reports',
                subMenu: 'EIP/Enr, Not Served',
                routeName: 'data-monitoring-reports/eligible-enrolled-not-served',
                name: 'Eligible, Enrolled, not Served',
                enableFeature: true
            },
            {
                id: 65,
                menu: 'SSDP Reports',
                subMenu: 'MPO 1.0',
                routeName: 'ssdp/mpo1',
                name: 'SSDP MPO 1.0 Report',
                enableFeature: true
            },
            {
                id: 66,
                menu: 'SSDP Reports',
                subMenu: 'MPO 2.0',
                routeName: 'ssdp/mpo2',
                name: 'SSDP MPO 2.0 Report',
                enableFeature: true
            },
            {
                id: 67,
                menu: 'SSDP Reports',
                subMenu: 'MPO 5.0, 6.0',
                routeName: 'ssdp/mpo5-6',
                name: 'SSDP HS Case Management Report (MPO 5.0, 6.0)',
                enableFeature: true
            },
            {
                id: 68,
                menu: 'SSDP Reports',
                subMenu: 'MPO 5.1, 6.1',
                routeName: 'ssdp/mpo5_1-6_1',
                name: 'SSDP HS Credit Accrual Report (MPO 5.1, 6.1)',
                enableFeature: true
            },
            {
                id: 69,
                menu: 'SSDP Reports',
                subMenu: 'MPO 7.0',
                routeName: 'ssdp/mpo7',
                name: 'SSDP MPO 7.0 Report',
                enableFeature: true
            },
            {
                id: 70,
                menu: 'SSDP Reports',
                subMenu: 'MPO 8.0',
                routeName: 'ssdp/mpo8',
                name: 'SSDP MPO 8.0 Report',
                enableFeature: true
            },
            {
                id: 71,
                menu: 'SSDP Reports',
                subMenu: 'MPO 9.0',
                routeName: 'ssdp/mpo9',
                name: 'SSDP MPO 9.0 Report',
                enableFeature: true
            },
            {
                id: 72,
                menu: 'SSDP Reports',
                subMenu: 'MPO 9.1',
                routeName: 'ssdp/mpo9_1',
                name: 'SSDP MPO 9.1 Report',
                enableFeature: true
            },
            {
                id: 73,
                menu: 'SSDP Reports',
                subMenu: 'MPO 10.0',
                routeName: 'ssdp/mpo10',
                name: 'SSDP MPO 10.0 Report',
                enableFeature: true
            },
            {
                id: 74,
                menu: 'SSDP Reports',
                subMenu: 'MPO 10.1',
                routeName: 'ssdp/mpo10_1',
                name: 'SSDP MPO 10.1 Report',
                enableFeature: true
            },
            {
                id: 75,
                menu: 'SSDP Reports',
                subMenu: 'MPO 10.2',
                routeName: 'ssdp/mpo10_2',
                name: 'SSDP MPO 10.2 Report',
                enableFeature: true
            },
            {
                id: 76,
                menu: 'SSDP Reports',
                subMenu: 'MPO 11.0',
                routeName: 'ssdp/mpo11',
                name: 'SSDP MPO 11.0 Report',
                enableFeature: true
            },
            {
                id: 77,
                menu: 'SSDP Reports',
                subMenu: 'MPO 11.1',
                routeName: 'ssdp/mpo11_1',
                name: 'SSDP MPO 11.1 Report',
                enableFeature: true
            },
            {
                id: 78,
                menu: 'SSDP Reports',
                subMenu: 'MPO 13.0',
                routeName: 'ssdp/mpo13',
                name: 'SSDP MPO 13.0 Report',
                enableFeature: true
            },
            {
                id: 79,
                menu: 'SSDP Reports',
                subMenu: 'MPO 13.1',
                routeName: 'ssdp-reports/MPO13_1',
                name: 'SSDP MPO 13.1 Report',
                enableFeature: true
            },
            {
                id: 80,
                menu: 'SSDP Reports',
                subMenu: 'SSDP Annual Report',
                routeName: 'ssdp-reports/ssdp-annual-report',
                name: 'Search SSDP Annual Reports',
                enableFeature: true
            },
            {
                id: 85,
                menu: 'Resources',
                subMenu: 'CDE/MEO',
                routeName: 'cdemeo',
                name: 'View Resources',
                enableFeature: true
            },
            {
                id: 86,
                menu: 'Resources',
                subMenu: 'MSIX',
                routeName: 'msix',
                name: 'View Resources',
                enableFeature: true
            },
            {
                id: 87,
                menu: 'MSIX',
                subMenu: 'MSIX Manual',
                routeName: 'msixmanual',
                name: 'View Resources',
                enableFeature: true
            },
            {
                id: 88,
                menu: 'Resources',
                subMenu: 'MEP Help Center',
                routeName: 'mep',
                name: 'View Resources',
                enableFeature: true
            },
            {
                id: 89,
                menu: 'Resources',
                subMenu: 'Results',
                routeName: 'results',
                name: 'View Resources',
                enableFeature: true
            },
            {
                id: 90,
                menu: 'Resources',
                subMenu: 'MSIN',
                routeName: 'msin',
                name: 'View Resources',
                enableFeature: true
            },
            {
                id: 91,
                menu: 'Resources',
                subMenu: 'User Guides',
                routeName: 'userguides',
                name: 'View Resources',
                enableFeature: true
            },
            {
                id: 92,
                menu: 'Resources',
                subMenu: 'Training',
                routeName: 'training',
                name: 'View Resources',
                enableFeature: true
            },
            {
                id: 93,
                menu: 'Resources',
                subMenu: 'Release Notes',
                routeName: 'releasenotes',
                name: 'View Resources',
                enableFeature: true
            },

            {
                id: 95,
                menu: 'Schools',
                subMenu: 'Search Schools',
                routeName: 'school/search',
                name: 'Search Schools',
                enableFeature: true
            },

            {
                id: 105,
                menu: 'System',
                subMenu: 'Accounts',
                routeName: 'system/manage/accounts',
                name: 'View System Accounts',
                enableFeature: true
            },
            {
                id: 106,
                menu: 'Accounts',
                subMenu: 'Search Accounts',
                routeName: 'accounts/search',
                name: 'Search Accounts',
                enableFeature: true
            },
            {
                id: 107,
                menu: 'Accounts',
                subMenu: 'Create Account',
                routeName: 'accounts/create',
                name: 'Create Accounts',
                enableFeature: true
            },
            {
                id: 108,
                menu: 'Accounts',
                subMenu: 'Login Audits',
                routeName: 'accounts/login-audits',
                name: 'View Login Audits',
                enableFeature: true
            },
            {
                id: 109,
                menu: 'Accounts',
                subMenu: 'Roles',
                routeName: 'accounts/roles',
                name: 'Edit Roles',
                enableFeature: true
            },
            {
                id: 110,
                menu: 'Accounts',
                subMenu: 'Features',
                routeName: 'accounts/features',
                name: 'Edit Features',
                enableFeature: true
            },
            {
                id: 111,
                menu: 'Accounts',
                subMenu: 'Permissions',
                routeName: 'accounts/permissions',
                name: 'Edit Permissions',
                enableFeature: true
            },
            {
                id: 112,
                menu: 'Accounts',
                subMenu: 'Global Admin',
                routeName: 'accounts/global-admin',
                name: 'View Global Admin',
                enableFeature: true
            },

            {
                id: 113,
                menu: 'Workflows',
                subMenu: 'Edit Workflows',
                routeName: 'workflows/edit',
                name: 'Edit Workflows',
                enableFeature: true
            },
            {
                id: 114,
                menu: 'Workflows',
                subMenu: 'Create Workflows',
                routeName: 'workflows/create',
                name: 'Create Workflows',
                enableFeature: true
            },
            {
                id: 115,
                menu: 'Workflows',
                subMenu: 'All Workbench Items',
                routeName: 'workflows/all',
                name: 'View All Workbench Items',
                enableFeature: true
            },
            {
                id: 116,
                menu: 'Organizations',
                subMenu: 'Search Organizations',
                routeName: 'organizations/search',
                name: 'Search Organizations',
                enableFeature: true
            },
            {
                id: 117,
                menu: 'Organizations',
                subMenu: 'Create Organization',
                routeName: 'system/manage/organizations/create',
                name: 'Create Organizations',
                enableFeature: true
            },
            {
                id: 118,
                menu: 'Organizations',
                subMenu: 'Email Domains',
                routeName: 'email-domains/edit',
                name: 'Edit Email Domains',
                enableFeature: true
            },
            {
                id: 119,
                menu: 'SystemSchools',
                subMenu: 'Create Schools',
                routeName: 'school/create',
                name: 'Create Schools',
                enableFeature: true
            },
            {
                id: 120,
                menu: 'School Districts',
                subMenu: 'Search School Districts',
                routeName: 'system/schoolDistricts',
                name: 'Search School Districts',
                enableFeature: true
            },
            {
                id: 121,
                menu: 'School Districts',
                subMenu: 'Create School Districts',
                routeName: 'system/schoolCreateDistricts',
                name: 'Create School Districts',
                enableFeature: true
            },
            {
                id: 122,
                menu: 'Counties',
                subMenu: 'Search Counties',
                routeName: 'county/search',
                name: 'Search Counties',
                enableFeature: true
            },
            {
                id: 123,
                menu: 'Counties',
                subMenu: 'Create Counties',
                routeName: 'county/create',
                name: 'Create Counties',
                enableFeature: true
            },
            {
                id: 124,
                menu: 'Persons',
                subMenu: 'Search Persons',
                routeName: 'persons/search',
                name: 'Search Persons',
                enableFeature: true
            },
            {
                id: 125,
                menu: 'Persons',
                subMenu: 'Create Person',
                routeName: 'persons/create',
                name: 'Create Persons',
                enableFeature: true
            },
            {
                id: 126,
                menu: 'System',
                subMenu: 'Administer Services',
                routeName: 'administer-services/search',
                name: 'Search Service Administrations',
                enableFeature: true
            },
            {
                id: 127,
                menu: 'System',
                subMenu: 'Edit Locations',
                routeName: 'locations/edit',
                name: 'Edit Locations',
                enableFeature: true
            },
            {
                id: 128,
                menu: 'System',
                subMenu: 'Edit Dashboard',
                routeName: 'dashboard/edit',
                name: 'Edit Dashboard',
                enableFeature: true
            },
            {
                id: 129,
                menu: 'System',
                subMenu: 'Edit Dashboard123',
                routeName: 'dashboard/edit123',
                name: 'Edit Dashboard123',
                enableFeature: true
            },
            {
                id: 130,
                menu: 'System',
                subMenu: 'Organization',
                routeName: 'system/organization',
                name: 'View System Organizations',
                enableFeature: true
            },
            //

            {
                id: 150,
                menu: '',
                subMenu: '',
                routeName: 'Edit Account Status',
                name: 'Edit Account Status',
                enableFeature: true
            },
            {
                id: 151,
                menu: '',
                subMenu: '',
                routeName: 'Edit Account Contact Information',
                name: 'Edit Account Contact Information',
                enableFeature: true
            },
            {
                id: 29,
                menu: '',
                subMenu: '',
                routeName: 'children/edit',
                name: 'Edit Students',
                enableFeature: true
            },
            {
                id: 30,
                menu: '',
                subMenu: '',
                routeName: 'children/view',
                name: 'View Students',
                enableFeature: true
            },
            {
                id: 1001,
                menu: '',
                subMenu: '',
                routeName: 'coe-2010/view',
                name: 'View COE',
                enableFeature: true
            },
            {
                id: 1002,
                menu: '',
                subMenu: '',
                routeName: 'coe-2017/view',
                name: 'View COE',
                enableFeature: true
            },
            {
                id: 1003,
                menu: 'Data Monitoring Reports',
                subMenu: 'Provisional Schools',
                routeName: 'data-monitoring-reports/provisional-schools',
                name: 'Provisional Schools Report',
                enableFeature: true
            },
            {
                id: 1004,
                menu: 'Children',
                subMenu: 'Resolve SSIDs',
                routeName: 'children/resolve-ssid',
                name: 'Resolve CALPADS SSID Resolutions',
                enableFeature: true
            },       
            {
                id: 1005,
                menu: 'SDP Reports',
                subMenu: 'MPO 1.0',
                routeName: 'sdp/mpo1',
                name: 'SDP MPO 1.0 Report',
                enableFeature: true
            },                 
            {
                id: 1006,
                menu: 'SDP Reports',
                subMenu: 'MPO 2.0',
                routeName: 'sdp/mpo2',
                name: 'SDP MPO 2.0 Report',
                enableFeature: true
            },                 
            {
                id: 1007,
                menu: 'SDP Reports',
                subMenu: 'MPO 4.1',
                routeName: 'sdp/mpo4.1',
                name: 'SDP MPO 4.1 Report',
                enableFeature: true
            },                 
            {
                id: 1008,
                menu: 'SDP Reports',
                subMenu: 'MPO 5',
                routeName: 'sdp/mpo5',
                name: 'SDP MPO 5.0 Report',
                enableFeature: true
            },                 
            {
                id: 1009,
                menu: 'SDP Reports',
                subMenu: 'MPO 6',
                routeName: 'sdp/mpo6',
                name: 'SDP MPO 6.0 Report',
                enableFeature: true
            },                 
            {
                id: 1010,
                menu: 'SDP Reports',
                subMenu: 'MPO 7',
                routeName: 'sdp/mpo7',
                name: 'SDP MPO 7.0 Report',
                enableFeature: true
            },                             
            {
                id: 1011,
                menu: 'SDP Reports',
                subMenu: 'MPO 9',
                routeName: 'sdp/mpo9',
                name: 'SDP MPO 9.0 Report',
                enableFeature: true
            },
            {
                id: 1012,
                menu: 'SDP Reports',
                subMenu: 'MPO 10',
                routeName: 'sdp/mpo10',
                name: 'SDP MPO 10.0 Report',
                enableFeature: true
            },                                         
            {
                id: 1013,
                menu: 'SDP Reports',
                subMenu: 'MPO 10.1',
                routeName: 'sdp/mpo10.1',
                name: 'SDP MPO 10.1 Report',
                enableFeature: true
            },                                                     
            {
                id: 1014,
                menu: 'SDP Reports',
                subMenu: 'MPO 11.0',
                routeName: 'sdp/mpo11',
                name: 'SDP MPO 11.0 Report',
                enableFeature: true
            },                                                                 
            {
                id: 1015,
                menu: 'SDP Reports',
                subMenu: 'MPO 11.1',
                routeName: 'sdp/mpo11.1',
                name: 'SDP MPO 11.1 Report',
                enableFeature: true
            },                                                                             
            {
                id: 1016,
                menu: 'SDP Reports',
                subMenu: 'MPO 13.0',
                routeName: 'sdp/mpo13',
                name: 'SDP MPO 13.0 Report',
                enableFeature: true
            },                                                                             

        ];
    }
}
